import Link from "next/link";

function Tag(params: {
  title: string;
  href: string;
  text?: "black" | "white";
}) {
  return (
    <Link
      href={params.href}
      className=" py-[8px] px-[12px] rounded-full
       font-semibold text-[12px] tracking-[-0.36px] !no-underline text-center"
      style={
        params.text === "black"
          ? { backgroundColor: "#D9D9D9", color: "#6F6F6F" }
          : { backgroundColor: "#757575", color: "white" }
      }
    >
      {params.title}
    </Link>
  );
}

export default Tag;
